module.exports = __webpack_public_path__ + "img/pin-map6.22c794ac.png";